import { Component, OnInit } from '@angular/core';
import { AppSettings } from './../../modules/shared/app.settings';
import { UserCommonService } from './../../modules/shared/services/user-common.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { StorageService } from './../../modules/shared/services/storage.service';
import { CommonBindingDataService } from '../../modules/shared/services/common-binding-data.service';
import { NotificationsService } from './../../modules/shared/services/notifications.service';
import { ErrorBindingService } from '../../modules/shared/services/error-binding.service';
import { UiService } from 'app/modules/shared/services/ui.service';
import { MessagingService } from 'app/modules/shared/services/messaging.service';
import { environment } from 'environments/environment';
import { GlobalConfigService } from 'app/modules/global-config/services/global-config.service';

@Component({
  selector: 'app-sign-in-layout',
  templateUrl: './sign-in-layout.component.html'
})

export class SignInLayoutComponent implements OnInit {
  signInResponse: any;
  otpId;
  forgotPopup = false;
  loginErrors = [{
    email: false,
    password: false,
  }];
  subscription: Subscription;
  otpPopup = false;
  setPasswordPopup = false;
  isMetadataLoaded = false;
  otpEmail;
  otpPhone;
  data;

  signInWelcomeTextLabel;
  signInDescription;
  readMoreLabel;
  labelResetPassword;
  labelValidateOtp;
  isCompanyRole = false;
  message1;
  deviceInfo = null;
  notification_token;
  device_details;
  samlLoginUrl = environment.samlLoginUrl;
  reportDownloadUrl: any;
  keyVal: any;
  signInVersion = environment.signInVersion;
  constructor(
    private userCommonService: UserCommonService,
    private router: Router,
    private storageService: StorageService,
    private commonBindingDataService: CommonBindingDataService,
    private notificationService: NotificationsService,
    private errorBindingService: ErrorBindingService,
    private uiService: UiService,
    private messagingService: MessagingService,
    private route: ActivatedRoute,
    private globalConfigService: GlobalConfigService

  ) {
    // this.router.navigate(['/signin-sso']);
  }

  ngOnInit() {
    this.notificationService.canFetchNotification = false;
    this.storageService.setLocalStorage('isLogout', false);
    this.messagingService.requestPermission();
    this.signInWelcomeTextLabel = this.commonBindingDataService.getLabel('label_sign_in_welcome_text');
    this.signInDescription = this.commonBindingDataService.getLabel('label_sign_in_description');
    this.readMoreLabel = this.commonBindingDataService.getLabel('label_read_more');
    this.labelResetPassword = this.commonBindingDataService.getLabel('label_reset_password');
    this.labelValidateOtp = this.commonBindingDataService.getLabel('label_validate_otp');
    const isIntervalCheck = this.storageService.getItemLocalStorage(AppSettings.INTERVAL);
    this.reportDownloadUrl = localStorage.getItem('returnUrl');

    //  this.route.queryParams.subscribe(params => {
    //   this.reportDownloadUrl = params.returnUrl;
    // });
  }

  doSignIn(signInData) {
    this.signInApiCall(signInData);
  }

  doSignInSSO() {
    this.userCommonService.signInSSO().subscribe(results => {
    }, error => {
    });
  }

  signInApiCall(signInData) {
    this.storageService.removeAllCookies();

    // web push notification :: notification token :: start
    this.notification_token = this.storageService.getItem('notificationToken');
    const ba = ['Chrome', 'Firefox', 'Safari', 'Opera', 'MSIE', 'Trident', 'Edge'];
    let b;
    const ua = navigator.userAgent;
    for (let i = 0; i < ba.length; i++) {
      if (ua.indexOf(ba[i]) > -1) {
        b = ba[i];
        break;
      }
    }
    if (b === 'MSIE' || b === 'Trident' || b === 'Edge') {
      b = 'Internet Explorer';
    }

    const temp = {
      deviceName: b,
      deviceType: 'web',
      os: navigator.platform,
      notificationToken: this.notification_token,
    };
    this.device_details = temp;
    signInData.deviceDetails = this.device_details;
    this.userCommonService.signIn(JSON.stringify(signInData)).subscribe(signInResult => {
      if (signInResult) {
        this.signInResponse = signInResult;
        sessionStorage.setItem('userRoleId', signInResult.user.roleId)
        sessionStorage.setItem('providerId', signInResult.user.id)
        this.storageService.setLocalStorage('userId', signInResult.user.id);

        if (this.signInResponse.accessGroup !== null && this.signInResponse.accessGroup.length > 0) {
          this.notificationService.canFetchNotification = true;
          this.setSessionAndUserDetails(signInResult);
          this.userCommonService.getUserMasterMetaData();
          this.userCommonService.getAdminUserMetaData();
          this.userCommonService.setRolesAndGenerateSidebar();
          this.userCommonService.getDispatchListFilter();
          this.userCommonService.getContactListFilter();
          const idleTime = Number(this.commonBindingDataService.getTenantConfigValue('session_timeout_in_mins')) ?
            Number(this.commonBindingDataService.getTenantConfigValue('session_timeout_in_mins')) : AppSettings.IDLE_TIME;
          // this.storageService.setItem('idleTime', AppSettings.IDLE_TIME);
          this.storageService.setItem('idleTime', idleTime);
          this.storageService.setLocalStorage('idleTime', idleTime);
          this.storageService.setItemInCookies('sessionToken', signInResult.sessionToken);
          localStorage.setItem('saveAppointmentDraft', signInResult.saveAppointmentDraft);
          this.reportDownloadUrl = localStorage.getItem('returnUrl');
          // if (this.reportDownloadUrl ) {
          //   if(this.reportDownloadUrl.includes("?")){
          //     const qParam = this.reportDownloadUrl.split('?')[1].split('&');
          //     let query = {};
          //     let newArry = [];
          //     newArry = qParam.map(item => item.split('=')).reduce((a, b) => a.concat(b));
          //     for (let i = 0; i < newArry.length; i++) {
          //       const s = newArry[i].replace(/['"]+/g, '');
          //       if (!(i % 2)) {
          //         query[newArry[i]] = newArry[i + 1];
          //       }
          //     }
          //     this.router.navigate([this.reportDownloadUrl.split('?')[0]], { queryParams: query });

          //   } else {
          //     this.router.navigate([this.reportDownloadUrl]);
          //   }
          // }
        } else {
          this.uiService.showMessage(this.commonBindingDataService.getLabel('error_invalid_access_group'), AppSettings.MESSAGE_TYPES.ERROR);
        }
      }
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  setSessionAndUserDetails(results) {
    console.log("results",results)
    this.storageService.setItem(AppSettings.USER_DETAILS, results.user);
    this.storageService.setItem(AppSettings.ACCESS_MENU, this.signInResponse.accessGroup);
    this.storageService.setItem('internalCheckListPermissions', results.internalCheckListPermissions);
    this.storageService.setItem('sdohScreeningPermissions', results.sdohScreeningPermissions);
    if(results.addDispatch){
      this.storageService.setItem('headerAccessPermissionDispatch', results.addDispatch);
    }
    if (results.addContactForm) {
      this.storageService.setItem('headerAccessPermissionContactForm', results.addContactForm);
    }
    if (results.viewContactForm) {
      this.storageService.setItem('accessPermissionViewContactForm', results.viewContactForm);
    }
    this.storageService.setItem('accessPermissionViewDispatchForm', results.viewDispatchForm);
    this.storageService.setItem(AppSettings.SHIFT_APPLICABLE, results.shiftApplicable);
    AppSettings.USER = results.user;
    this.setTagList();
    this.getGlobalConfigurations();
    if (results.user.userDetails !== null) {
      this.storageService.setItem(AppSettings.CURRENT_USER_CORPORATE_ID, results.user.userDetails.corporateId);
    }
  }

  setTagList() {
    this.userCommonService.getTagsListApi().subscribe(result => {
      this.storageService.setItem(AppSettings.TAG_DATA, result);
      localStorage.setItem('localTagdata', JSON.stringify(result));
    }, (error) => {
    });
  }

  moduleWiseRouteAccesses() {
    const groups = {};
    let accesses = this.signInResponse.accesses;
    for (let i = 0; i < accesses.length; i++) {
      const accessGroupName = accesses[i].accessGroupName;
      if (!groups[accessGroupName]) {
        groups[accessGroupName] = [];
      }
      groups[accessGroupName].push(accesses[i].accessName);
    }
    accesses = [];
    for (const accessGroupName in groups) {
      if (groups.hasOwnProperty(accessGroupName)) {
        accesses.push({ group: accessGroupName, accessName: groups[accessGroupName] });
      }
    }
    this.storageService.setItem(AppSettings.ACCESS_LIST, accesses);
  }

  uniqArray(arrArg) {
    return arrArg.filter((elem, pos, arr) => {
      return arr.indexOf(elem) === pos;
    });
  }

  forgotPassword() {
    this.router.navigate(['/forgot-password']);
  }

  onPopClose(event) {
    this.forgotPopup = false;
  }

  onOtpPopClose(event) {
    this.otpPopup = false;
  }

  onSetPasswordPopClose(event) {
    this.setPasswordPopup = false;
  }

  onOtpPopSave(event) {
    if (event.general !== undefined) {
      this.uiService.showMessage(event.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    } else {
      if (event.otpId) {
        this.otpId = event.otpId;
        this.uiService.showMessage(this.commonBindingDataService.getLabel('matched_otp'), AppSettings.MESSAGE_TYPES.SUCCESS);
        this.setPasswordPopup = true;
      }
    }
    this.forgotPopup = false;
    this.otpPopup = false;
  }

  onPopSave(results) {
    this.otpEmail = results;
    this.otpPhone = results.phone;
    this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
    this.forgotPopup = false;
    this.otpPopup = true;
  }

  getGlobalConfigurations() {
    this.globalConfigService.getGlobalConfigList().subscribe((res) => {
        if(res.shiftConfigurations.length > 0 && res.dutyMasterConfigurations.length > 0) {
          const globalConfig = [...res.shiftConfigurations, ...res.dutyMasterConfigurations];
          localStorage.setItem(AppSettings.GLOBAL_CONFIG, JSON.stringify(globalConfig));
        }
    }, (err) => {

    })
  }

}
